import React from "react"
import SurveyViewer from "../../components/SurveyViewer"
import "./Surveys.css"
import { Modal, message, Tree, Button, Row, Col, Drawer, Space, Carousel, Avatar, Form, Input, Select, TimePicker, Switch ,Tabs,Checkbox} from 'antd';

export const MunicipalitySurvey = (props) => {
return(
    <div className="bigSurveyPage">    
    <div className="bigSurveyContent">
        <SurveyViewer  visible={true} bigSurvey={true} surveyId={1} />
        </div>
    </div>
    )
}